import React from 'react';
import {FaLock} from 'react-icons/fa';
import {BiCabinet} from "react-icons/bi";
import PropTypes from 'prop-types';
export const QrTypeIcon = ({type}) =>{
	return (
			<>
					{type === 'lock'
						? <FaLock/>
						:	<BiCabinet/>
					}
			</>
	)
}
QrTypeIcon.propTypes = {
	id: PropTypes.string,
	type:PropTypes.string,
};
